// extracted by mini-css-extract-plugin
module.exports = {"cpNotice":"bsehD","cpCon":"Q6yRG","body":"_1U4Ym","btn":"UGgG-","footer":"_3BIa2"};